module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"signup":"Signup","login":"Login"},"fr":{"signup":"S\u0027inscrire","login":"Se connecter"}}')
  delete Component.options._Ctor
}
